module.exports = __webpack_public_path__ + "img/who-are-you--guardian.dcc900d5.svg";